module.exports = __webpack_public_path__ + "static/img/icon_delete_nor.1e4bc571.svg";